import classNames from 'classnames';
import PropTypes from 'prop-types';

import { DefaultLink } from 'hb-react/frontoffice/components/Link';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import * as mobileDeviceFromUserAgent from 'helpers/mobileDeviceFromUserAgent';

import style from './index.module.scss';

const Expert = ({
  name,
  photo_url: photoUrl,
  photo_thumb_url: photoThumbUrl,
  new_photo: newPhoto,
  headline,
  user_id: userId,
  id,
}) => {
  const { whitelabelURL } = useTopicContext();
  const { flagEvUserPicturesToGlobalStorage } = useFeatureFlag();

  const mobileView = !!mobileDeviceFromUserAgent.any();
  const content = (
    <>
      <img
        data-testid="expert-picture"
        className="user-item__img push-half--bottom"
        src={
          flagEvUserPicturesToGlobalStorage
            ? newPhoto?.medium_url
            : photoUrl || photoThumbUrl
        }
        aria-label={__('Expert Picture')}
      />
      <div className="h5 flush color-dark-gray soft-quarter--sides break-word">
        {name}
      </div>
    </>
  );

  return (
    <div
      className={classNames('grid__item text--center push-half--bottom', {
        'one-half': mobileView,
        'one-quarter': !mobileView,
        [style.component]: true,
      })}
      data-toggle="tooltip"
      data-toggle-cursor="none"
      data-title={headline}
      data-testid="expert-headline"
    >
      {whitelabelURL ? (
        content
      ) : (
        <DefaultLink href={Routes.user_path(userId || id)} target="_blank">
          {content}
        </DefaultLink>
      )}
    </div>
  );
};

Expert.propTypes = {
  name: PropTypes.string.isRequired,
  photo_url: PropTypes.string,
  photo_thumb_url: PropTypes.string,
  headline: PropTypes.string,
  user_id: PropTypes.number,
  id: PropTypes.number,
};

export default Expert;
